import { HttpClient } from '@angular/common/http';
import { Component, ElementRef,  EventEmitter,  HostBinding, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ConfigService } from '@icc/shared';

@Component({
    selector: 'icc-external-menu-panel',
    templateUrl: './external-menu-panel.component.html',
    styleUrls: ['./external-menu-panel.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class ExternalMenuPanelComponent {
    template: SafeHtml | null = null;
    @ViewChild('externalMenuElement', { static: true }) content: ElementRef<HTMLDivElement> | null = null;

    @HostBinding('class.active')
    active = false;

    constructor(private httpClient: HttpClient, private sanitizer: DomSanitizer, private configService: ConfigService, private element: ElementRef<HTMLDivElement>) {}

    ngOnInit() {
        this.httpClient.get('/api/b2b/ext-menu', {
            responseType: 'text',
        }).toPromise().then((res: any) => {
            this.template = this.sanitizer.bypassSecurityTrustHtml(res);
            this.active = true;
            setTimeout(() => {
                (window as any).extMenuShadowRoot = this.element.nativeElement.shadowRoot;
                const toggleScript = this.content.nativeElement.querySelector<HTMLScriptElement>('#menu-toggle-script');
                const scriptCopy = <HTMLScriptElement>document.createElement('script');
                scriptCopy.type = toggleScript.type ? toggleScript.type : 'text/javascript';
                if (toggleScript.innerHTML) {
                    scriptCopy.innerHTML = toggleScript.innerHTML.replace(/document\./g, 'extMenuShadowRoot.');
                } else if (toggleScript.src) {
                    scriptCopy.src = toggleScript.src;
                }
                scriptCopy.async = false;
                toggleScript.parentNode.replaceChild(scriptCopy, toggleScript);
            });
        });
    }
}
